(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  var $slider = $('.custom-slick-slider .slick-slider');
  var $progressBar = $('.slider-progress .progress-bar');
  var $prev = $('.custom-prev');
  var $next = $('.custom-next');

   $slider.on('init reInit afterChange', function(event, slick, currentSlide){
    var i = (currentSlide ? currentSlide : 0) + 2;
    var progress = (i / slick.slideCount) * 100;
    $progressBar.css('width', progress + '%');
  });

  $slider.slick({
    slidesToShow: 2.2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  });

    $prev.on('click', function(){ $slider.slick('slickPrev'); });
  $next.on('click', function(){ $slider.slick('slickNext'); });

  // Trick: Move track to right using transform
  $slider.find('.slick-track').css({
    'margin-left': 'auto',
    'margin-right': '0'
  });
});

  } catch(e) { console.error(e); }
})();
})();
